export default __webpack_public_path__ + "static/media/a017-market-8.28908690.svg";